import { Info } from 'lucide-react';

/**
 * Requisito del spec (UX): tiene que verse, no esconderse en un "acerca de".
 * Tono neutro y sin alarmismo.
 */
export function MedicalDisclaimer({ compact = false }: { compact?: boolean }) {
  if (compact) {
    return (
      <p className="px-1 py-3 text-center text-xs text-[var(--color-text-muted)]">
        NutriGym no sustituye el consejo de un médico ni de un dietista-nutricionista.
      </p>
    );
  }

  return (
    <div className="flex gap-3 rounded-[var(--radius-card)] border border-[var(--color-border)] bg-[var(--color-surface-2)] p-3 text-sm">
      <Info aria-hidden="true" className="mt-0.5 size-5 shrink-0 text-[var(--color-info)]" />
      <p className="text-[var(--color-text-muted)]">
        NutriGym es una herramienta de registro. <strong>No sustituye</strong> el consejo de un
        médico ni de un dietista-nutricionista, y sus recomendaciones son orientativas.
      </p>
    </div>
  );
}
